import ErrorPage from "../../components/ErrorPage"
import { hrefForCurrentCinema } from "../../lib/cinemaSlugs"

export default function NotFound() {
    return (
        <ErrorPage
            code="404"
            accentColor="#349be6"
            illustration="not-found"
            stickers={[
                { label: "не в афише 🎬", color: "#349be6", rotate: -2 },
                { label: "пустой зал 🪑", color: "#29cc6a", rotate: 2 },
                { label: "билет недействителен 🎟", color: "#e4206b", rotate: -1 },
            ]}
            title={
                <>
                    Такого <span style={{ color: "#349be6" }}>сеанса</span> нет
                </>
            }
            description="Похоже, эта страница не в программе кинотеатра. Проверьте адрес или вернитесь к афише — там точно есть, на что сходить."
            marquee={["страница не найдена", "проверьте адрес", "сеанс отменён", "возвращайтесь в зал"]}
            primaryAction={{ label: "К афише", to: hrefForCurrentCinema("/afisha") }}
            secondaryAction={{ label: "На главную", to: "/" }}
        />
    )
}
